import Highcharts from 'highcharts';
import { getTowingData } from "./chart-towing";

/**
 * @param {string} id
 */
export default function chartWrecks(id) {
    if (!document.getElementById(id)) return;

    const cityData = getTowingData().sort((a, b) => b.wrecksPer100k - a.wrecksPer100k);
    const categories = cityData.map(item => item.city);
    const wrecksData = cityData.map(item => item.wrecksPer100k);

    Highcharts.chart(id, {
        chart: { type: 'bar', backgroundColor: 'transparent' },
        title: { text: 'Removed wrecks per 100k residents' },
        xAxis: {
            categories: categories,
            title: { text: null },
            labels: { style: { fontSize: '14px' } }
        },
        yAxis: {
            min: 0,
            title: { text: 'Number of wrecks' }
        },
        tooltip: {
            shared: true,
            pointFormat: '<b>{point.y}</b> wrecks per 100k residents'
        },
        plotOptions: {
            bar: {
                dataLabels: { enabled: true },
                borderRadius: 4
            }
        },
        legend: { enabled: false },
        credits: { enabled: false },
        series: [{
            name: 'Removed wrecks',
            data: wrecksData,
            color: '#7f8c8d'
        }]
    });
}
